import { render } from "./admissionResultsLienthong.vue?vue&type=template&id=522d544c&ts=true"
import script from "./admissionResultsLienthong.vue?vue&type=script&lang=ts"
export * from "./admissionResultsLienthong.vue?vue&type=script&lang=ts"

import "./admissionResultsLienthong.vue?vue&type=style&index=0&id=522d544c&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__